export default "__VITE_ASSET__CJv2XnId__"